<div class="flex flex-col w-full h-full bg-white rounded-2xl overflow-hidden">
    <!-- Header -->
    <div class="flex justify-between items-center px-6 py-5 border-b border-gray-200">
        <div class="flex items-center gap-2">
            <button mat-icon-button (click)="toggleMenu()" class="w-9 h-9 text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200">
                <mat-icon class="icon-size-6" [svgIcon]="'mat_solid:compare_arrows'"></mat-icon>
            </button>
            <h2 class="text-[20px] font-semibold font-inter text-gray-900 m-0">Faturamento</h2>
        </div>
        <button mat-icon-button (click)="closeModal()" class="w-9 h-9 text-gray-500 hover:bg-gray-100 hover:text-gray-900 transition-all duration-200">
            <mat-icon class="icon-size-6" [svgIcon]="'mat_outline:close'"></mat-icon>
        </button>
    </div>

    <!-- Content -->
    <div class="flex flex-1 overflow-hidden relative">
        <!-- Backdrop overlay para mobile -->
        <div
            class="sm:block it:hidden absolute inset-0 bg-black z-40 transition-opacity duration-300"
            [ngClass]="{
                'opacity-50 pointer-events-auto': isMenuOpen,
                'opacity-0 pointer-events-none': !isMenuOpen
            }"
            (click)="toggleMenu()">
        </div>

        <!-- Sidebar Menu -->
        <div
            class="bg-gray-50 border-r border-gray-200 overflow-y-auto transition-all duration-300 flex-shrink-0 h-full p-3
                   sm:absolute sm:left-0 sm:top-0 sm:z-50
                   it:relative it:z-10"
            [ngClass]="{
                'w-[250px] sm:shadow-2xl it:shadow-none': isMenuOpen,
                'w-0 p-0 border-r-0 sm:-translate-x-full': !isMenuOpen
            }">
            <div class="flex flex-col gap-1" *ngIf="isMenuOpen">
                <div
                    *ngFor="let item of visibleMenuItems"
                    class="flex items-center px-3 py-3 rounded-xl cursor-pointer transition-all duration-200 group"
                    [class.bg-[#eff7ff]]="item.active"
                    [class.hover:bg-[#eff7ff]]="!item.active"
                    (click)="selectMenuItem(item.id)">
                    <mat-icon
                        class="icon-size-5 transition-all duration-200"
                        [class.text-[#0061ff]]="item.active"
                        [class.text-gray-900]="!item.active"
                        [class.group-hover:text-[#0061ff]]="!item.active"
                        [svgIcon]="item.icon"></mat-icon>
                    <span
                        class="ml-2 text-[14px] font-inter transition-all duration-200"
                        [class.text-[#0061ff]]="item.active"
                        [class.font-semibold]="item.active"
                        [class.font-medium]="!item.active"
                        [class.text-gray-900]="!item.active"
                        [class.group-hover:text-[#0061ff]]="!item.active">
                        {{ item.title }}
                    </span>
                </div>
            </div>
        </div>

        <!-- Main Content Area -->
        <div class="flex-1 overflow-hidden bg-white">
            <!-- Plano e Assinatura -->
            <plan-subscription *ngIf="selectedMenuItem === 'plan-subscription'"></plan-subscription>

            <!-- Métodos de Pagamento -->
            <payment-methods *ngIf="selectedMenuItem === 'payment-methods'"></payment-methods>

            <!-- Histórico de Pagamentos -->
            <payment-history *ngIf="selectedMenuItem === 'payment-history'"></payment-history>

            <!-- Dados de Cobrança -->
            <billing-data *ngIf="selectedMenuItem === 'billing-data'"></billing-data>
        </div>
    </div>
</div>
